export const ButtonXs = ({ children, onClick, color, text, size,disabled }) => (
    <button onClick={onClick} disabled={disabled?disabled:false}  className={` ${disabled === true && "opacity-50"}  flex justify-center items-center font-normal rounded-[4px] border border-[${color}] bg-[${color}] text-[${text}] ${size === "xs" ? "py-[10px] leading-[12px] text-[12px] px-4" : "py-[12px] leading-4 px-[20px] text-[14px]"}`}>
        {children}
    </button>
);

export const ButtonHollowXs = ({ children, color, text, size,disabled }) => (
    <button 
    disabled={disabled?disabled:false}
    className={`  ${disabled === true && "opacity-50"} flex justify-center items-center font-normal rounded-[4px] border border-[${text}] ${size === "xs" ? "py-[10px] leading-[12px] text-[12px] px-4" : "py-[12px] leading-4 px-[20px] text-[14px]"} ${color === "transparent" ? "" : `bg-[${color}]`} text-[${text}]`}>
        {children}
    </button>
);
